/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Student_student = {|
  +id: string;
  +firstname: ?string;
  +lastname: ?string;
  +profilePictureThumbnailUri: ?string;
  +startedJobSessionCount: ?number;
  +pendingJobRequestsCount: ?number;
  +cellphoneNumber: ?string;
  +user: {|
    +email: string;
    +status: string;
    +active: boolean;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Student_student",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "lastname",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StudentBooked_student",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StudentHistory_student",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "firstname",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StudentPending_student",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "profilePictureThumbnailUri",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "startedJobSessionCount",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pendingJobRequestsCount",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "cellphoneNumber",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "active",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Student"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/student/__generated__/Student_student.graphql.js